import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { colors } from '../../config/colors';

export default function LandingMapLegend() {
  const { t } = useLocale();

  const items = [
    { labelKey: 'landingLegendOwnFacility', color: colors.brand[500] },
    { labelKey: 'landingLegendSupplier', color: colors.secondary[500] },
    { labelKey: 'landingLegendGeography', color: colors.info[500] },
    { labelKey: 'landingLegendLogisticsRoute', color: colors.brand[500], line: true },
    { labelKey: 'landingLegendGraphRoute', color: colors.secondary[500], line: true },
  ];

  return (
    <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
      {items.map(({ labelKey, color, line }) => (
        <div key={labelKey} className="flex items-center gap-2 text-xs text-text-secondary">
          {line ? (
            <span className="h-0.5 w-5 rounded-full" style={{ backgroundColor: color }} />
          ) : (
            <span className="size-2.5 rounded-full" style={{ backgroundColor: color }} />
          )}
          <span>{t(labelKey)}</span>
        </div>
      ))}
    </div>
  );
}
